import { render } from "./AccordionItemComponent.vue?vue&type=template&id=9bd031e4"
import script from "./AccordionItemComponent.vue?vue&type=script&lang=js"
export * from "./AccordionItemComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__